<template>
  <div class="input-file">
    <input type="file" class="input-file__hidden" ref="file" :accept="acceptFilter" @change="onFileSelected">

    <button :class="btnClass" class="js-upload-file" @click.prevent="onChooseFileClick" v-if="mode === 'button'">{{$t(label)}}</button>
    <div class="input-file__item-empty" @click="onChooseFileClick" v-else>
      <span class="input-file__name input-file__name_empty " v-t="'labels.no-file-selected'"></span>
    </div>

    <signing-dialog ref="signing" @signed="onSignaturePrepared"></signing-dialog>

    <confirmation-dialog ref="confirmation" close-on-action>
      <template v-slot:body>
        <slot name="question">
        </slot>
      </template>
    </confirmation-dialog>
  </div>
</template>

<script>
  import SigningDialog from '@/components/common/dialogs/SigningDialog'
  import formattedSize from '@/libs/pretty-size'
  import hasher from 'js-sha256'
  import ConfirmationDialog from "../dialogs/ConfirmationDialog";

  export default {
    props: {
      mode: {
        type: String,
        default: 'button'
      },

      signing: {
        type: Boolean,
        default: true
      },

      btnClass: {
        type: String,
        default: 'gui-btn gui-btn--upload'
      },

      label: {
        type: String,
        default: 'labels.select-file'
      },

      accept: {
        type: [String, Array]
      },

      confirmation: {
        type: String
      }
    },

    components: {
      ConfirmationDialog,
      SigningDialog
    },

    data: () => ({
      file: undefined
    }),

    computed: {
      acceptFilter() {
        let extensions;

        if (this.accept === undefined) {
          extensions = this.$store.getters.getFilesLimits.extensions;
        }
        else if (typeof this.accept === 'string') {
          extensions = this.$store.getters.getFilesLimits.extensions.filter(ext => ext === this.accept);
        }
        else {
          extensions = this.$store.getters.getFilesLimits.extensions.filter(ext => this.accept.includes(ext));
        }

        return extensions.map(e => '.' + e).join(',');
      }
    },

    methods: {
      onChooseFileClick() {
        if (this.confirmation) {
          this.$refs.confirmation.open({
            title: this.confirmation,
            onConfirm: () => this.$refs.file.click()
          })
        }
        else {
          this.$refs.file.click();
        }
      },

      signSelectedFile(file) {
        const reader = new FileReader();
        const crypto = window.crypto || window.msCrypto;

        reader.onload = async (event) => {
          //
          // const buffer = new ArrayBuffer(8); //await crypto.subtle.digest('SHA-256', event.target.result);
          // const array = Array.from(new Uint8Array(buffer));
          // const hash = array.map(byte => ('00' + byte.toString(16)).slice(-2)).join('');

          const hash = hasher.sha256.hex(event.target.result);

          this.file = file;
          this.$refs.signing.open({ file, hash });
        };

        reader.readAsArrayBuffer(file);
      },

      onSignaturePrepared(result) {
        this.$refs.signing.close();

        this.$emit('prepared', {
          file: this.file,
          hash: result.data,
          sign: result.signature
        });
      },

      onFileSelected(ev, data) {
        if (ev.target.files.length === 0) return;

        const file = ev.target.files[0];
        ev.target.value = '';

        let valid = true;

        if (file) {
          const ext = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
          const limit = this.$store.getters.getFilesLimits.limits[ext];

          if (limit && limit < file.size) {
            valid = false;
            const expectedSize = formattedSize(limit);

            this.showError({
              title: 'Слишком большой файл',
              error: 'Размер файла не должен превышать ' + expectedSize.size + this.$t(expectedSize.label)
            });
          }
        }

        if (valid) {
          if (this.signing) {
            this.signSelectedFile(file)
          }
          else {
            this.$emit('prepared', file);
          }
        }
      },
    }
  }
</script>

<style scoped>
  .gui-btn--upload {

  }
</style>
